export default __webpack_public_path__ + "static/media/hm-bold.520be5c6.eot";